class DeliveryTime extends HTMLElement {
    constructor() {
        super();

        this.formatString = this.getAttribute('data-frm-day') || 'd, DD MMM';
        this.excludedDays = (this.getAttribute('data-exclude-day') || '')
            .replace(/ /g, '')
            .split(',')
            .filter(Boolean);
        this.numbDateStart = this.getAttribute('data-estimate-start') || 0;
        this.numbDateEnd = this.getAttribute('data-estimate-end') || 0;
        this.targetTime = this.getAttribute('data-time');
        this.hr = this.querySelector('.productView-dlvr__remaining-hr');
        this.mins = this.querySelector('.productView-dlvr__remaining-mins');
        this.isoCode = document.documentElement.lang || 'de';
        this.countdownTimer = null;

        if (this.checkExcludedDay(this.excludedDays)) return;

        this.productDeliveryTime();
        this.updateCountdown();
        this.style.display = 'block';

        if (this.targetTime && this.hr && this.mins) {
            this.countdownTimer = window.setInterval(() => this.updateCountdown(), 60000);
        }
    }

    disconnectedCallback() {
        if (this.countdownTimer) window.clearInterval(this.countdownTimer);
    }

    checkExcludedDay(excludedDays) {
        const currentDay = new Date().getDay();
        return excludedDays.some((day) => {
            return ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(day) === currentDay;
        });
    }

    productDeliveryTime() {
        const startElement = this.querySelector('[data-start-delivery]');
        const endElement = this.querySelector('[data-end-delivery]');

        if (!startElement || !endElement) return;

        const startDay = this.excludeDays(this.excludedDays, this.numbDateStart);
        const endDay = this.excludeDays(this.excludedDays, this.numbDateEnd);

        startElement.textContent = this.formatDate(startDay, this.formatString);
        endElement.textContent = this.formatDate(endDay, this.formatString);
    }

    formatDate(dateString, formatString) {
        const date = new Date(dateString);
        const dayOfWeek = date.toLocaleDateString(this.isoCode, { weekday: 'long' });
        const dayOfMonth = date.toLocaleDateString(this.isoCode, { day: '2-digit' });
        const month = date.toLocaleDateString(this.isoCode, { month: 'short' });
        const monthNumber = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.toLocaleDateString(this.isoCode, { year: 'numeric' });

        return formatString
            .replace('d', dayOfWeek)
            .replace('DD', dayOfMonth)
            .replace('MMM', month)
            .replace('MM', monthNumber)
            .replace('YYYY', year);
    }

    excludeDays(excludedDays, dataRange) {
        const deliveryDateTime = new Date();
        deliveryDateTime.setDate(deliveryDateTime.getDate() + parseInt(dataRange, 10));

        excludedDays.forEach((day) => {
            const dayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(day);
            if (deliveryDateTime.getDay() === dayIndex) {
                deliveryDateTime.setDate(deliveryDateTime.getDate() + 1);
            }
        });

        return deliveryDateTime;
    }

    updateCountdown() {
        if (!this.targetTime || !this.hr || !this.mins) return;

        const countdown = this.countdownToTime(this.targetTime);
        this.hr.textContent = countdown.hours;
        this.mins.textContent = countdown.minutes;
    }

    countdownToTime(targetTime) {
        const currentTime = new Date();
        const targetDateTime = new Date(`${currentTime.toDateString()} ${targetTime}`);

        if (targetDateTime < currentTime) targetDateTime.setDate(targetDateTime.getDate() + 1);

        const remainingTime = targetDateTime - currentTime;
        const hours = Math.floor(remainingTime / (1000 * 60 * 60));
        const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));

        return { hours, minutes };
    }
}

if (!customElements.get('delivery-time')) {
    customElements.define('delivery-time', DeliveryTime);
}
